export default __webpack_public_path__ + "static/chema-192909dc541bec121526593f58ef6422.jpg";